import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import StockModel from '../models/StockModel';

interface StockInputState {
    input: StockModel,
    selectedStockId: string,
    StockInputExpand: boolean,
    triggerFocusCompanyNameInput: number,
    triggerSave: number,
    triggerRefreshInput: number,
    stockItems: string[],
    showStockDetail: boolean
}

const initialState: StockInputState = {
    input: {
        id: "",
        date: "",
        description: "",
        items: "",
        sellAmount: 0,
        buyAmount: 0,
        totalValue: 0,
    } as unknown as StockModel,
    selectedStockId: "",
    StockInputExpand: true,
    triggerFocusCompanyNameInput: 0,
    triggerSave: 0,
    triggerRefreshInput: 0,
    stockItems: [],
    showStockDetail: false
}

export const StockInputSlice = createSlice({
    name: "StockInput",
    initialState,
    reducers: {
        setStockInputId: (state, action: PayloadAction<string>) => {
            state.input.id = action.payload;
        },
        setStockInput: (state, action: PayloadAction<StockModel>) => {
            state.input = action.payload;
        },
        setItems: (state, action: PayloadAction<string>) => {
            state.input.items = action.payload;
        },
        setDate: (state, action: PayloadAction<string>) => {
            state.input.date = action.payload;
        },
        setDescription: (state, action: PayloadAction<string>) => {
            state.input.description = action.payload;
        },
        setSellAmount: (state, action: PayloadAction<number>) => {
            state.input.sellAmount = action.payload;
        },
        setBuyAmount: (state, action: PayloadAction<number>) => {
            state.input.buyAmount = action.payload;
        },
        setTotalValue: (state, action: PayloadAction<number>) => {
            state.input.totalValue = action.payload;
        },
        setSelectedStockId: (state, action: PayloadAction<string>) => {
            state.selectedStockId = action.payload;
        },
        setStockInputExpand: (state, action: PayloadAction<boolean>) => {
            state.StockInputExpand = action.payload;
        },
        setTriggerFocusCompanyNameInput: (state, action: PayloadAction<number>) => {
            state.triggerFocusCompanyNameInput = action.payload;
        },
        resetStockInput: (state) => {
            state.input = initialState.input;
        },
        setTriggerSave: (state, action: PayloadAction<number>) => {
            state.triggerSave = action.payload;
        },
        setTriggerRefreshInput: (state, action: PayloadAction<number>) => {
            state.triggerRefreshInput = action.payload;
        },
        setStockItems: (state, action: PayloadAction<string[]>) => {
            state.stockItems = action.payload;
        },
        setShowStockDetail: (state, action: PayloadAction<boolean>) => {
            state.showStockDetail = action.payload;
        },
    }
});

export const StockInputSelector = createSelector(
    (state: RootState) => state.stockInput,
    (data) => data
);

export const {
    setStockInputId,
    setStockInput,
    setItems,
    setDate,
    setDescription,
    setSellAmount,
    setBuyAmount,
    setTotalValue,
    setSelectedStockId,
    setStockInputExpand,
    setTriggerFocusCompanyNameInput,
    resetStockInput,
    setTriggerSave,
    setTriggerRefreshInput,
    setStockItems,
    setShowStockDetail
} = StockInputSlice.actions;

export default StockInputSlice.reducer;